import { StatusMessage as IsStatusMessage } from 'is24-corecss'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div<{ textColor?: string; borderColor?: string; backgroundColor?: string }>`
  div {
    border-color: ${({ borderColor }) => `${borderColor} !important`};
    ::before {
      color: ${({ borderColor }) => `${borderColor} !important`};
    }
  }
  ${({ textColor }) => `color: ${textColor} !important`};
  ${({ backgroundColor }) =>
    backgroundColor &&
    `
      div {
        background: ${backgroundColor} !important
      }
  `};
`

type IsStatusMessageProps = React.ComponentProps<typeof IsStatusMessage>

interface StatusMessageProps extends IsStatusMessageProps {
  textColor?: string
  borderColor?: string
  backgroundColor?: string
}
const StatusMessage = ({ textColor, borderColor, backgroundColor, ...props }: StatusMessageProps): ReactElement => {
  return (
    <Wrapper
      textColor={textColor}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      data-testid='test-status'
    >
      <IsStatusMessage {...props} />
    </Wrapper>
  )
}

export { StatusMessage, StatusMessageProps }
